import { cn } from "@/lib/utils/cn";
import * as React from "react";

// Base UI has no standalone Label primitive (use `Field.Label` inside a Field).
// For labels outside a Field, a native <label> is the idiomatic primitive:
// htmlFor gives native click-to-focus, and `select-none` covers the only thing
// a dedicated Label primitive would add (no text-selection on double-click).
const Label = ({
  className,
  isDirty = false,
  required = false,
  streaming = false,
  ...props
}: React.ComponentProps<"label"> & {
  isDirty?: boolean;
  required?: boolean;
  streaming?: boolean;
}) => {
  return (
    <label
      data-slot="label"
      className={cn(
        "text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        className,
      )}
      {...props}
    >
      {props.children}
      {required && <span className="text-red-500 ml-0.5">•</span>}
      {isDirty && (
        <span
          className="ml-1.5 inline-flex items-center rounded-full bg-blue-100 px-1.5 py-0.5 text-[10px] font-medium text-blue-700 dark:bg-blue-900/50 dark:text-blue-300"
          data-testid="dirty-indicator"
        >
          Edited
        </span>
      )}
      {streaming && (
        <span className="ml-1.5 inline-flex items-center rounded-full bg-muted px-1.5 py-0.5 text-[10px] font-medium text-muted-foreground animate-pulse">
          Loading...
        </span>
      )}
    </label>
  );
};

export { Label };
